import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { DocumentNavigationServiceBase } from '@bases/document-navigation-service/document-navigation.service.base';
import { Document } from '@models/document';

@Injectable({
  providedIn: 'root'
})
export class DocumentViewService extends DocumentNavigationServiceBase {
  protected getById(documentId: number): Observable<Document> {
    return this.documentApiService.getDocument(documentId, 'expense_report');
  }
}
